import React from 'react'
import { useSearchParams } from 'react-router'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { MainContainer } from '@core/Components/Containers'
import type { FollowListTabNav } from '@core/Areas/FollowMe/types'
import { FollowList } from './Components/FollowList'

export const ProfileFollowList: React.FC<{ profileId: string }> = ({ profileId }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabCurrent: FollowListTabNav = (searchParams.get('tab') as FollowListTabNav) || 'followers'

  const handleTabClick = (tabContent: FollowListTabNav) => {
    setSearchParams({ tab: tabContent })
  }

  return (
    <MainContainer background='surface300'>
      <Tabs>
        <TabButton
          content='Followers'
          isSelected={tabCurrent === 'followers'}
          onClick={() => {
            handleTabClick('followers')
          }}
        />
        <TabButton
          content='Following'
          isSelected={tabCurrent === 'following'}
          onClick={() => {
            handleTabClick('following')
          }}
        />
      </Tabs>

      <div>
        <FollowList currentList={tabCurrent} profileId={profileId} />
      </div>
    </MainContainer>
  )
}
